<template>
  <div>
    <NavBar />
    <ExamTable />
  </div>
</template>
  
<script>
import NavBar from "../components/NavBar.vue";
import ExamTable from "../components/ExamTable.vue";

export default {
  components: {
    NavBar,
    ExamTable,
  },
};
</script>